export default "__VITE_ASSET__BC01UERN__"